import React, { useEffect, memo, useState } from "react";
import {
    Switch,
    useColorModeValue,
    Button,
    TagLabel,
    Box,
    Center,
    Text,
} from "@chakra-ui/react";
import { getAccount, getAuthUrl, updateUser } from "../../utils/sessionHelper";
import { useSession } from "next-auth/react";
import * as analytics from "../../utils/analytics";
import { textStyle, variant } from "theme/names";

export const ActivateAnalytics = ({callback=undefined as Function | undefined}) => {
  const { data: session, status } = useSession() ?? {}
  const loading = status === "loading"


    const [isLoading, setIsLoading] = useState(false);

    return (
      <Box display="flex" justifyContent="center">
        <Center maxW="400px" mt={20} display="flex" flexDirection="column">
          <Text textStyle={textStyle["body.medium.light"]}>
            Press the button bellow to start fetching your posts data. This can
            take up to a few minutes.
          </Text>
          <Button
            isLoading={isLoading}
            mt={5}
            maxW="300px"
            // colorScheme="twitter"
            variant={variant.Button.primary}
            onClick={async () => {
              setIsLoading(true);

              if (callback) await callback();
            }}
          >
            Start Using Posts Analytics
          </Button>
        </Center>
      </Box>
    );
}

